import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-partnerships',
    templateUrl: './partnerships.component.html',
    styleUrl: './partnerships.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnershipsComponent {}
